import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import {
  AreasSelector,
  Filters,
  ActiveFilterViewer,
} from '@rankmi/rankmi-table'
import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import { COURSE, QueryCourseAllArgs, TDataCourse } from 'graphqlAPI'
import { IAreaModel } from 'models/area.model'
import * as fromAreaActions from 'store/actions/areas.action'
import { IMainState } from 'store/states'
import { Columns } from './constants'
import { useFiltersColumns } from './hooks'
import { CourseProgress, Users } from './components'

export interface StatisticsProps {
  course: string
  isSynchronous: boolean
}

export const Statistics = ({ course, isSynchronous }) => {
  const { areas, loading: areasLoading } = useSelector(
    ({ areas }: IMainState) => areas
  )
  const dispatch = useDispatch()
  const [area, setArea] = useState<IAreaModel | null>(null)
  const [filterData, setFilterData] = useState<IFilterData>({
    data: [
      {
        group: 0,
        input: Columns.userLmsActive,
        type: 'tagsList',
        operator: 'eq',
        compareTo: 'true',
        index: 0,
        condition: 'and',
      },
    ],
    generalCondition: 'and',
    filterType: 'simple',
  })

  const [showFiltersModal, setShowFiltersModal] = useState(false)
  useEffect(() => {
    dispatch({ type: fromAreaActions.GET_AREAS_LIST })
  }, [dispatch])
  const {
    data: dataCourse,
    loading: loadingCourse,
    refetch: refetchCourse,
  } = useQuery<TDataCourse, QueryCourseAllArgs>(COURSE, {
    variables: { id: course, areaId: area?.id?.toString() },
  })

  const filtersColumns = useFiltersColumns({
    isSynchronous,
    course: dataCourse?.course,
  })

  return (
    <div>
      <Row>
        <Col
          xs={12}
          md={2}
          className="d-flex flex-column justify-content-center"
        >
          <AreasSelector
            areas={areas}
            loading={areasLoading}
            mandatoryArea={false}
            onAreaSelected={(area: IAreaModel) => {
              setArea(+area.id === 0 ? null : area)
            }}
          />
        </Col>
        <Col xs={12}>
          <Row className="mb-3">
            <CourseProgress courseId={course.toString()} areaId={area?.id} />
          </Row>
        </Col>
        <Col xs={12}>
          <Users
            courseId={course}
            course={dataCourse?.course}
            loadingCourse={loadingCourse}
            refetchCourse={refetchCourse}
            area={area}
            filterData={filterData}
            filters={
              <Filters
                columns={filtersColumns}
                onChange={(value) => setFilterData(value)}
                open={showFiltersModal}
                onVisibilityChange={(state: boolean) =>
                  setShowFiltersModal(state)
                }
                selectedFilters={filterData}
              />
            }
            filtersView={
              filterData && (
                <ActiveFilterViewer
                  activeFilters={filterData}
                  onChange={(data: any) => setFilterData(data)}
                  openFilters={(state: boolean) => setShowFiltersModal(state)}
                  columns={filtersColumns}
                />
              )
            }
          />
        </Col>
      </Row>
    </div>
  )
}

export default Statistics
